import { requestApi } from './Api';

export const changeEmail = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/user/security/change_email',
    params,
    throwError: true
  });

export const changePassword = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/user/security/change_password',
    params,
    throwError: true
  });

export const sendPhoneVerification = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/user/mfa/start',
    params: {
      ...params,
      kind: 'sms'
    },
    throwError: true
  });

export const verifyPhone = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/user/mfa/complete',
    params,
    throwError: true
  });

export const updatePhoneNumber = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/user/update_phone_number',
    params,
    throwError: true
  });

export const setupTotp = async (navigate) =>
  requestApi({
    navigate,
    url: '/api/user/mfa/totp/setup',
    params: {},
    throwError: true
  });

export const activateTotp = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/user/mfa/totp/activate',
    params,
    throwError: true
  });

export const disableTotp = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/user/mfa/totp/disable',
    params,
    throwError: true
  });

export const fallbackToSms = async (navigate) =>
  requestApi({
    navigate,
    url: '/api/user/mfa/fallback',
    params: {},
    throwError: true
  });

export const confirmMfaCode = async (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/user/mfa/confirm',
    params,
    throwError: true
  });
